import React from "react";
import "./styles.scss";
import { Button } from "..";
import { GetIconByName } from "../../config/icon";

const DetailsNotFound = (props) => {
  const [isLoading, setIsLoading] = React.useState();
  return (
    <>
      <div className={`details-not-found-wrapper `}>
        <div className="emw-icon">{GetIconByName("file-close")}</div>
        <div className="emw-title"> {props.title} </div>
        <div className="emw-subTitle">{props.subTitle}</div>
        <Button
          data={{
            btnName: "REFRESH",
            buttonType: "black-border",
            buttonSize: "xs",
            isLoading: isLoading,
          }}
          onClick={props?.onClickRefresh}
        />
      </div>
    </>
  );
};
export default DetailsNotFound;
